import { render, staticRenderFns } from "./trashCan.vue?vue&type=template&id=ff57ad48&scoped=true&"
import script from "./trashCan.vue?vue&type=script&lang=js&"
export * from "./trashCan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff57ad48",
  null
  
)

export default component.exports